import {useState,useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {setMetricCreator,upsertMetricCategoryData} from './slice'
import {useMetricCreator} from './hooks'
import {useClients} from '../users/hooks'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import {dateToYMD} from '../../util/datetime'
import useCurrentUser from '../../hooks/useCurrentUser'
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'


const MetricCreator = ()=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()

	const {status,clients} = useClients()

	const [selectedClient,setSelectedClient] = useState(
		isClient
		? {value:user.user_id_number,label:user.user_name}
		: null
	)

	const [date,setDate] = useState(new Date())

	const {show,category,allowSave} = useMetricCreator()
	const handleClose = ()=>{
		dispatch(setMetricCreator({
			category:null,
			show:false,
			client:null,
			metrics:null,
			date:null
		}))
	}

	useEffect(()=>{
		if(isClient){
			setSelectedClient({value:user.user_id_number,label:user.user_name})
			dispatch(setMetricCreator({client:selectedClient.value}))
		}
	},[show])

	const handleSelectClient = selected => {
		setSelectedClient(selected)
		dispatch(setMetricCreator({client:selected.value}))
	}

	const handleSelectDate = selected => {
		setDate(selected)
		dispatch(setMetricCreator({date:dateToYMD(selected)}))
	}

	const [isSaving,setIsSaving] = useState(false)
	const handleSave = ()=>{
		setIsSaving(true)
		statusDispatch(
			upsertMetricCategoryData(),
			'metric data',
			'create'
		).then(()=>{
			setIsSaving(false)
			handleClose()
		})
	}

	return (
		<Modal style={{zIndex:'1500'}} show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				Add {category} to {isClient?'':'Client'} Progress
			</Modal.Header>
			<Modal.Body>
				{!isClient&&
					<>		
						<strong>Choose a Client</strong>
						<Select
							onChange={handleSelectClient}
							selected={selectedClient}
							options={clients.map(c=>({
								label:c.user_name,
								value:c.user_id_number
							}))}
						/>
					</>
				}

				<strong className="d-block mt-3">Choose a Date</strong>
				<div>
					<DatePicker
						customInput={<Form.Control size="sm"/>}
						onChange={handleSelectDate}
						selected={date}
					/>
				</div>
				<div className="mt-3">
					<small>
						<i className="fa fa-info-circle mr-1"/> This will automatically create a "{category}" category (if not yet created) and add all metric data to it.
					</small>
				</div>

				<div className="text-right mt-3">
					<Button 
						disabled={!allowSave||isSaving}
						onClick={handleSave}
						variant="outline-success"
						size="sm"
					>
						Add to Metric Progress Data {isSaving&&<Spinner animation="border" size="sm"/>}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default MetricCreator